import Check from "@/assets/icons/Check";
import { useTranslation } from "react-i18next";
import { Upsell } from "@/@types/Upsell";
import { Button } from "@/components/ui/button";
import { ScriptComponent } from "./ScriptComponent";
import { bodyScript, externalScript } from "@/lib/script-options";

interface FinishStepProps {
  upsell: Upsell;
  onBack: () => void;
}

export default function FinishStep({ upsell, onBack }: FinishStepProps) {
  const { t } = useTranslation("upsells");
  return (
    <div className="flex items-center justify-center p-4">
      <div className="w-full max-w-lg space-y-8">
        <div className="flex flex-col items-center space-y-4">
          <div className="w-12 h-12 bg-[#1A1A1A] rounded-xl flex items-center justify-center">
            <Check />
          </div>
          <div className="text-center space-y-2">
            <h1 className="text-xl font-medium text-white">
              {t("finishStep.title")}
            </h1>
            <p className="text-[#A1A1AA] text-sm leading-relaxed">
              {t("finishStep.description")}
            </p>
          </div>
        </div>

        <div className="relative space-y-6">
          <div className="absolute left-[19px] top-10 bottom-10 w-[1px] border-l border-dashed border-zinc-800"></div>
          <div className="flex gap-4 items-start">
            <div className="w-8 h-8 flex-shrink-0 bg-[#1A1A1A] rounded-lg flex items-center justify-center text-white text-xs">
              1
            </div>
            <ScriptComponent
              title={
                <>
                  {t("paste_code_inside")}{" "}
                  <code className="text-primary">&lt;head&gt;</code>
                </>
              }
              script={externalScript()}
            />
          </div>
          <div className="flex gap-4 items-start">
            <div className="w-8 h-8 flex-shrink-0 bg-[#1A1A1A] rounded-lg flex items-center justify-center text-white text-xs">
              2
            </div>
            <ScriptComponent
              title={
                <>
                  {t("paste_code_inside")}{" "}
                  <code className="text-primary">&lt;body&gt;</code>
                </>
              }
              script={bodyScript(upsell)}
            />
          </div>
          <div className="flex gap-4 items-start">
            <div className="w-8 h-8 flex-shrink-0 bg-[#1A1A1A] rounded-lg flex items-center justify-center text-white text-xs">
              3
            </div>
            <div className="flex-1">
              <p className="text-white text-sm">
                {t("finishStep.steps.savePublish")}
              </p>
            </div>
          </div>
          <div className="flex gap-4 items-start">
            <div className="w-8 h-8 flex-shrink-0 bg-[#1A1A1A] rounded-lg flex items-center justify-center text-white text-xs">
              4
            </div>
            <div className="flex-1">
              <p className="text-white text-sm">
                {t("finishStep.steps.testIntegration")}
              </p>
            </div>
          </div>
        </div>

        <Button onClick={onBack} variant="secondary" className="block m-auto">
          {t("finishStep.backButton")}
        </Button>
      </div>
    </div>
  );
}
